import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import { useEffect, useRef } from 'react'

export default function DateRangePicker({ onChange, defaultRange }) {
  const dateRef = useRef(null)

  useEffect(() => {
    flatpickr(dateRef.current, {
      mode: 'range',
      static: true,
      enableTime: true,
      allowInput: true,
      closeOnSelect: true,
      defaultDate: defaultRange ? [defaultRange.start, defaultRange.end] : null,
      onChange: (selectedDates) => {
        if (!onChange) return
        if (!selectedDates || selectedDates.length < 2) {
          onChange(null)
          return
        }

        onChange({
          start: selectedDates[0],
          end: selectedDates[1],
        })
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultRange])

  return (
    <input
      type="text"
      placeholder="Select a date range"
      ref={dateRef}
      className="w-full border border-gray-300 rounded px-3 py-2 bg-secondary-50 focus:outline-none focus:ring-2 focus:ring-secondary-600"
    />
  )
}
